import {
  NotificationIcon as CoreNotificationIcon,
  useSession,
} from '@zhiyue/core';
import React from 'react';
import { useOpenPlatformToken } from '@/hooks/useOpenPlatformToken';
import { hasOAuth2Session } from '@/services/oauth2';

type NotificationIconProps = Omit<
  React.ComponentProps<typeof CoreNotificationIcon>,
  'token'
>;

const NotificationIcon: React.FC<NotificationIconProps> = (props) => {
  const { currentUser, loading } = useSession();
  const { token } = useOpenPlatformToken({
    enabled: !loading && Boolean(currentUser?.memberUuid) && hasOAuth2Session(),
    refreshKey: currentUser?.memberUuid,
  });

  if (loading || !currentUser?.memberUuid || !token) {
    return null;
  }

  return <CoreNotificationIcon {...props} token={token} />;
};

export default NotificationIcon;
